function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.692 16.7004C40.0096 22.4629 32.4616 29.1519 30.0159 31.3009L25.7943 34.9369C25.3395 35.3287 24.6603 35.3287 24.2055 34.9369L19.9839 31.3009C17.4987 29.1165 9.74302 22.2434 14.5286 16.4195C15.1515 15.6607 15.9459 15.0305 16.8459 14.6198C19.3683 13.4668 21.6387 14.1005 23.2491 15.0742L20.5467 21.4445C20.3811 21.8328 20.6715 22.2611 21.0999 22.2611H24.2679C24.6471 22.2611 24.9303 22.6022 24.8559 22.9669L23.8239 26.5651C23.7495 26.9309 24.2355 27.1386 24.4563 26.8341L29.1219 20.8344C29.4063 20.4437 29.1219 19.9009 28.6335 19.9009H25.9095C25.4787 19.9009 25.1883 19.4678 25.3587 19.0783L27.2199 14.8145C28.5507 14.1253 30.2139 13.7135 32.1339 14.2374C33.5608 14.6269 34.8136 15.5273 35.692 16.7004Z"
});

function SvgIcEee749F9998244939Ffc5875C334E0Da(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEee749F9998244939Ffc5875C334E0Da);
export default ForwardRef;